var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
import Cookies from 'js-cookie';
let isRefreshing = false;
let failedQueue = [];
const processQueue = function (error) {
  let token = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  failedQueue.forEach(prom => {
    if (token) prom.resolve(token);else prom.reject(error);
  });
  failedQueue = [];
};
export function setupInterceptors(api, onLogout, onError, accessTokenCookieKey, refreshTokenCookieKey, refreshTokenCallback) {
  api.interceptors.request.use(config => {
    const token = Cookies.get(accessTokenCookieKey);
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  }, error => Promise.reject(error));
  api.interceptors.response.use(response => response, error => __awaiter(this, void 0, void 0, function* () {
    var _a;
    const originalRequest = error.config;
    if (((_a = error.response) === null || _a === void 0 ? void 0 : _a.status) === 401 && !originalRequest._retry) {
      if (isRefreshing) {
        return new Promise((resolve, reject) => {
          failedQueue.push({
            resolve,
            reject
          });
        }).then(token => {
          originalRequest.headers.Authorization = `Bearer ${token}`;
          return api(originalRequest);
        }).catch(err => Promise.reject(err));
      }
      originalRequest._retry = true;
      isRefreshing = true;
      try {
        if (refreshTokenCallback === undefined) {
          throw new Error('Refresh token callback is not defined');
        }
        const data = yield refreshTokenCallback();
        if (!data || !data.accessToken) {
          throw new Error('Failed to refresh token');
        }
        Cookies.set(accessTokenCookieKey, data.accessToken, {
          secure: true,
          sameSite: 'Strict'
        });
        if (data === null || data === void 0 ? void 0 : data.refreshToken) {
          Cookies.set(refreshTokenCookieKey, data.refreshToken, {
            secure: true,
            sameSite: 'Strict'
          });
        }
        api.defaults.headers.Authorization = `Bearer ${data.accessToken}`;
        processQueue(null, data.accessToken);
        return api(originalRequest);
      } catch (refreshError) {
        processQueue(refreshError, null);
        Cookies.remove(accessTokenCookieKey);
        Cookies.remove(refreshTokenCookieKey);
        if (onLogout) {
          yield onLogout();
        }
        return Promise.reject(refreshError);
      } finally {
        isRefreshing = false;
      }
    }
    if (onError) {
      onError(error);
    }
    return Promise.reject(error);
  }));
}